<script lang="ts">
import { defineComponent, onMounted, reactive, Ref, ref } from 'vue';
import { AddressesStore } from 'stores/Addresses/Addresses.ts';
import { storeToRefs } from 'pinia';
import AddressesService from 'src/core/services/AddressesService';
import AddAddress from 'components/User/Addresses/AddAddress.vue';
import DeliveryAddressSelection from 'components/User/Order/Completion/DeliveryAddressSelection.vue';
import { useRoute } from 'vue-router';

type AddressSelectionType = 'shipping' | 'billing';

export default defineComponent({
  name: 'DeliveryAddressList',

  props: {
    loadDefaults: Boolean,
    modelValue: {
      type: Object,
      default: () => ({
        shippingAddress: null,
        billingAddress: null,
      }),
    },
    loading: Boolean,
    // shippingAddressId: {
    //   type: Number,
    //   default: null,
    // },
    // billingAddressId: {
    //   type: Number,
    //   default: null,
    // },
  },

  components: {
    DeliveryAddressSelection,
    AddAddress,
  },

  setup() {
    const addressesStore = AddressesStore();
    const { shippingAddress, billingAddress, noDataShippingAddress, noDataBillingAddress, addressesList } = storeToRefs(addressesStore);

    const defaultsLoading = ref(false);

    const editAddressDetail = ref(null);
    const editAddressDialog = ref(false);

    const addressActionLoading: Ref<{ [addressId: number]: boolean }> = ref({});

    const addressSelection = ref<{
      model: boolean;
      type: AddressSelectionType;
    }>({
      model: false,
      type: '',
    });

    const addressCreation = ref<{
      model: boolean;
      type: AddressSelectionType;
    }>({
      model: false,
      type: '',
    });

    const list = reactive({
      shippingAddress: {
        title: 'Teslimat Adresi',
        icon: 'fa-solid fa-truck',
        address: shippingAddress,
        type: 'shipping',
        noData: noDataShippingAddress,
      },
      billingAddress: {
        title: 'Fatura Adresi',
        icon: 'fa-solid fa-file-invoice',
        address: billingAddress,
        type: 'billing',
        noData: noDataBillingAddress,
      },
    });

    function getDefaultAddresses() {
      defaultsLoading.value = true;
      return Promise.all([addressesStore.getShippingAddress(), addressesStore.getBillingAddress()])
        .then(() => {
          defaultsLoading.value = false;
        })
        .catch(() => {
          defaultsLoading.value = false;
        });
    }

    return {
      getAddresses: addressesStore.getAddresses,
      getDefaultAddresses,
      getShippingAddress: addressesStore.getShippingAddress,
      getBillingAddress: addressesStore.getBillingAddress,
      getAddressDetail: AddressesService.addressDetail,
      shippingAddress,
      billingAddress,
      editAddressDialog,
      editAddressDetail,
      addressActionLoading,
      list,
      addressesList,
      defaultsLoading,
      addressSelection,
      addressCreation,
      noDataShippingAddress,
      noDataBillingAddress,
    };
  },

  methods: {
    editAddress(addressId: number) {
      /**
       * Düzenle denildiğinde id stora gönderilecek data
       * gelince düzenle açılacak ve düzenle içerisinde düzenle data
       * hazır bulunacak
       */
      AddressesService.addressDetail(addressId).then(({ status, data }) => {
        if (status._200_) {
          this.editAddressDetail = data;
          this.editAddressDialog = true;
        }
      });
    },

    openAddressSelection(type: AddressSelectionType) {
      this.addressSelection.type = type;
      this.addressSelection.model = true;
    },

    openAddressCreation(type: AddressSelectionType) {
      this.addressCreation.type = type;
      this.addressCreation.model = true;
    },

    selectAddress(addressId: number) {
      this.addressSelection.model = false;
      if (this.addressSelection.type === 'shipping') {
        this.shippingAddress = this.addressesList.list.find((addr) => addr.id === addressId);
      } else if (this.addressSelection.type === 'billing') {
        this.billingAddress = this.addressesList.list.find((addr) => addr.id === addressId);
      }
    },

    updateAddress(address) {
      const oldAddressIndex = this.addressesList.list.findIndex((addr) => addr.id === address.id);

      if (oldAddressIndex !== -1) {
        this.addressesList.list[oldAddressIndex] = address;
      } else {
        this.addressesList.list.push(address);
      }

      if (address.id === this.shippingAddress?.id) {
        this.shippingAddress = address;
      } else if (address.id === this.billingAddress?.id) {
        this.billingAddress = address;
      }
    },

    createAddress(address) {
      this.addressesList.list.push(address);

      if (this.addressCreation.type === 'shipping') {
        this.shippingAddress = address;
      } else if (this.addressCreation.type === 'billing') {
        this.billingAddress = address;
      }
      this.addressCreation.model = false;
    },
  },

  mounted() {
    if (this.$props.loadDefaults) {
      this.getDefaultAddresses();
    }
  },

  watch: {
    // shippingAddressId(newVal) {
    //   if (newVal) {
    //     this.getAddressDetail(newVal).then(({ status, data }) => {
    //       if (status._200_) {
    //         this.shippingAddress = data;
    //       }
    //     });
    //   }
    // },
    // billingAddressId(newVal) {
    //   if (newVal) {
    //     this.getAddressDetail(newVal).then(({ status, data }) => {
    //       if (status._200_) {
    //         this.billingAddress = data;
    //       }
    //     });
    //   }
    // },
    shippingAddress(val) {
      if (val) {
        this.noDataShippingAddress = false;

        if (this.noDataBillingAddress) {
          this.getBillingAddress();
        }
      }
    },
    billingAddress(val) {
      if (val) {
        this.noDataBillingAddress = false;
      }
    },
  },
});
</script>

<template>
  <div class="row q-col-gutter-md">
    <template v-if="loading || defaultsLoading">
      <div class="col-lg-4 delivery-address--body" :key="n" v-for="n in 2">
        <q-card class="bg-grey-3 delivery-address--wrapper">
          <q-card-section>
            <q-skeleton type="text" width="20%" animation-speed="450" />
            <q-skeleton type="text" width="50%" animation-speed="450" />
            <q-skeleton type="text" width="40%" animation-speed="450" />
            <q-separator class="q-my-md" />
            <q-skeleton type="text" height="30px" width="80%" animation-speed="450" />
            <q-skeleton type="text" height="30px" width="90%" animation-speed="450" />
          </q-card-section>
        </q-card>
      </div>
    </template>
    <div v-else :key="key" v-for="(item, key) in list" class="col-12 col-sm-6 col-lg-4 delivery-address--body">
      <h6 class="delivery-address--head">{{ item.title }}</h6>
      <q-card v-if="item.address" flat bordered class="delivery-address--wrapper">
        <q-card-section>
          <div class="row items-center no-wrap">
            <div class="col">
              <div class="delivery-address--address-namesurname">{{ item.address.namesurname }}</div>
              <div>
                {{ item.address.name }}
              </div>
              <div>
                <span class="text-grey-8">Telefon:</span>
                {{ item.address.telephone }}
              </div>
            </div>
            <div class="col-auto">
              <q-btn color="grey-7" round flat icon="more_vert" :loading="addressActionLoading[item.address.id]">
                <q-menu cover auto-close>
                  <q-list class="bg-grey-2">
                    <q-item clickable @click="openAddressSelection(item.type)">
                      <q-item-section>
                        <q-item-label class="flex items-center text-dark text-subtitle2 text-weight-bold">
                          <q-icon name="refresh" size="1.3em" class="q-mr-sm" />
                          Farklı Adres Seç
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                    <q-item clickable @click="editAddress(item.address.id)">
                      <q-item-section>
                        <q-item-label class="flex items-center text-dark text-subtitle2 text-weight-bold">
                          <q-icon name="create" size="1.3em" class="q-mr-sm" />
                          Düzenle
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-list>
                </q-menu>
              </q-btn>
            </div>
          </div>
        </q-card-section>

        <q-card-section>
          <span class="text-grey-8">Mahalle:</span>
          {{ item.address.neighbourhood }}
          <br />
          <span class="text-grey-8">Adres:</span>
          {{ item.address.address }}
          <span v-show="item.address.postcode">- {{ item.address.postcode }},</span>
          {{ item.address.district }}/{{ item.address.city }}
        </q-card-section>
        <q-separator />
      </q-card>
      <q-card v-if="item.noData" class="delivery-address--no-data">
        <q-card-section class="text-center">
          <q-icon name="info" size="3em" class="text-grey-5" />
          <div class="text-grey-8 text-subtitle1 text-weight-medium q-mt-md">Adres bulunamadı</div>
          <q-btn color="primary" class="q-mt-md" unelevated>
            <q-icon name="add" size="1rem" class="q-mr-sm" />
            Adres
            <q-menu>
              <q-list style="min-width: 100px">
                <q-item clickable v-close-popup @click="openAddressCreation(item.type)">
                  <q-item-section>Adres Ekle</q-item-section>
                </q-item>
                <q-item clickable v-close-popup @click="openAddressSelection(item.type)">
                  <q-item-section>Adres Seç</q-item-section>
                </q-item>
              </q-list>
            </q-menu>
          </q-btn>
        </q-card-section>
      </q-card>
    </div>

    <delivery-address-selection v-model="addressSelection.model" @change="selectAddress" />
    <add-address v-model="addressCreation.model" @update="createAddress" />
    <add-address v-model="editAddressDialog" :edit-detail="editAddressDetail" @update="updateAddress" />
  </div>
</template>

<style scoped lang="sass">
.delivery-address

  &--head
    font-size: 1rem
    margin: 0 0 1rem
    line-height: 1

  &--body
    display: flex
    flex-direction: column
    align-items: stretch

  &--wrapper
    border: 1px solid #ccc
    border-radius: 8px
    background-color: $grey-3

  &--address-namesurname
    font-size: 1rem
    font-weight: 600

  &--no-data
    display: flex
    flex-direction: column
    align-items: center
    justify-content: center
    flex-grow: 1
    background-color: $grey-2
    box-shadow: none
    border: 2px dashed #ccc
</style>
